import { ElvClient } from 'NM/@eluvio/elv-client-js/dist/src/ElvClient.js';
import Hls from 'NM/hls.js/dist/hls.min.js';

const ScreenerVideoEmbed = () => {
  const screeners = document.querySelectorAll('.screener-video-embed');

  if (screeners) {
    screeners.forEach(screener => {
      // Content Fabric settings
      const configUrl = 'https://main.net955305.contentfabric.io/config';
      const myObject = screener ? screener.getAttribute('data-obj') : '';
      const key = screener ? screener.getAttribute('data-key') : '';
      const watermark = screener ? screener.getAttribute('data-wm') : '';

      // App settings
      const libraryIdSite = 'ilib43iR9jL9B5FTcC2fya2rUxQLTkRq';
      const siteId = 'iq__3ZpUdyrRZe5g6JsfrUH1kMWnPVNy';
      const staticToken = 'eyJxc3BhY2VfaWQiOiJpc3BjMlJVb1JlOWVSMnYzM0hBUlFVVlNwMXJZWHp3MSIsImFkZHIiOiIweDlkNDU3YTU3NjAxOTZlZGEwNjExZWI1ODczODVlYWM2M2UzODgyMmIifQ==.RVMyNTZLXzlKa1c5RW9uV0t2VUxISEFudWVneHpGQXlSVExkckhEQlJaNktKdDZieUNKMkNIa0pjNVJzUzJ6RUFycjQxdlZEbnVtQ1B5QldzcHJZaGltNDgzTUd1V2E=';

      const InitBackend = async () => {
        const client = await ElvClient.FromConfigurationUrl({
          configUrl,
        });

        const wallet = client.GenerateWallet();
        const signer = wallet.AddAccount({
          privateKey: key,
        });

        client.SetSigner({ signer });
        client.ToggleLogging(false);

        return client;
      };

      const MakeToken = async ({ client, objectId, versionHash, subject }) => {
        const token = client.CreateSignedToken({
          objectId,
          versionHash,
          policyId: null,
          subject,
          grantType: 'read',
          duration: 60 * 60 * 1000, // millisec
        });

        return token;
      };

      const ViewTitle = async ({ versionHash, token }) => {
        const client = await ElvClient.FromConfigurationUrl({
          configUrl,
          staticToken: token,
        });

        const playoutOptions = await client.PlayoutOptions({
          versionHash,
        });

        const availableDRMs = await client.AvailableDRMs();

        LoadHlsJs(playoutOptions, availableDRMs, screener);
      };

      const ViewSite = async ({ libraryId, token }) => {
        const client = await ElvClient.FromConfigurationUrl({
          configUrl,
          staticToken: token,
        });

        client.ToggleLogging(false);

        const siteHash = await client.LatestVersionHash({
          libraryId,
          objectId: siteId,
        });

        const titles = await client.ContentObjectMetadata({
          libraryId,
          versionHash: siteHash,
          metadataSubtree: '/public/asset_metadata/titles',
        });

        return titles;
      };

      const ExtractHash = async ({ titles, slug }) => {
        const items = Object.values(titles);
        const length = items.length;
        for (let i = 1; i < length; i++) {
          if (Object.keys(items[ i ])[ 0 ] === slug) {
            const link = Object.values(items[ i ])[ 0 ][ '/' ];
            const hash = link.split('/')[ 2 ];
            return hash;
          }
        }
      };

      const LoadHlsJs = (playoutOptions, availableDRMs, elem) => {
        const playoutMethods = playoutOptions.hls.playoutMethods;

        let drm = 'aes-128';

        if (availableDRMs.includes('sample-aes')) {
          drm = 'sample-aes';
        }

        const playoutInfo = playoutMethods[ drm ] || playoutMethods.clear;
        const playerElement = elem.querySelector('video');

        // Use native player for sample AES
        if (drm === 'sample-aes') {
          playerElement.src = playoutInfo.playoutUrl;
          return;
        }

        const player = new Hls();
        player.loadSource(playoutInfo.playoutUrl);
        player.attachMedia(playerElement);
      };

      const Load = async () => {
        try {
          const subject = watermark;

          //
          // List titles in site
          //
          const titles = await ViewSite({ libraryId: libraryIdSite, token: staticToken });

          // Choose a title (e.g): 'bobhairn010a0223bob110-720'
          const titleHash = await ExtractHash({ titles, slug: myObject });

          //
          // Backend code - Create access tokens for the title that the user chose
          //
          const client = await InitBackend();
          const tokenTitle = await MakeToken({ client, versionHash: titleHash, subject });

          //
          // Frontend code - View one title
          //
          await ViewTitle({ versionHash: titleHash, token: tokenTitle });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      };

      const playBtn = screener.querySelector('.play-button');
      playBtn.addEventListener('click', Load);
    });
  }
};

export default ScreenerVideoEmbed;

